import styled from '@emotion/styled';

import colors from 'config/theme/colors';

export const ScrollWrapper = styled.div`
  height: 250px;
  overflow: hidden;
  overflow-y: auto;
  border: solid 1px ${colors['@input-border-color']};
  padding: 8px 12px;
  border-radius: 2px;
`;

export const Flex = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;

  > * {
    max-width: 50%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    &:last-child {
      flex-shrink: 0;
    }
  }
`;

export const ListItem = styled.div`
  display: block;
  padding: 12px;
  margin-bottom: 8px;
  border-radius: 2px;
  border-width: 1px;
  cursor: pointer;

  border: solid 1px ${colors['@border-light-grey']};
  border-top-color: transparent;
  border-left-color: transparent;
  border-right-color: transparent;

  &.selected {
    background-color: ${colors['@body-bg']};
  }

  &.disabled {
    opacity: 0.4;
  }

  &:hover:not(.selected) {
    background-color: ${colors['@body-bg']};
  }
`;

export const Reference = styled.strong`
  font-size: 16px;
`;
